/**
 * The origin of the Settings returned by the API.
 *
 * TODO: #5263 Convert to string enum after upgrade.
 *
 * @see mobiz1:Mobiz.Models.DTO.SettingsOrigin
 */
export type MobizSettingsOrigin =
  /**
   * Customized settings, already saved in the database
   */
  'DB' |
  /**
   * Default settings, not saved in the database
   */
  'Default' |
  /**
   * Settings not found on the Backend
   */
  'NotFound';
